<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Haze" class="d-icon d-icon--haze" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.246 2.746a.5.5 0 0 1 .708 0l.7.7a.5.5 0 1 1-.708.708l-.7-.7a.5.5 0 0 1 0-.708ZM.5 6.5A.5.5 0 0 1 1 6h1a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm9 0A.5.5 0 0 1 10 6h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm.254-3.754a.5.5 0 0 1 0 .708l-.7.7a.5.5 0 1 1-.708-.708l.7-.7a.5.5 0 0 1 .708 0ZM.5 8.5A.5.5 0 0 1 1 8h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm0 2A.5.5 0 0 1 1 10h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm3.732-5.768A2.5 2.5 0 0 1 8.5 6.5a.5.5 0 0 1-1 0 1.5 1.5 0 0 0-3 0 .5.5 0 0 1-1 0 2.5 2.5 0 0 1 .732-1.768ZM6 .75a.5.5 0 0 1 .5.5V2.5a.5.5 0 0 1-1 0V1.25a.5.5 0 0 1 .5-.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHaze',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
